import { Link, useLocation, useNavigate } from 'react-router-dom';
import { MapPin, Phone, Mail, ArrowRight } from 'lucide-react';

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavClick = (e, href) => {
    e.preventDefault();
    
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.querySelector(href);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const quickLinks = [
    { name: 'Inicio', href: '#inicio' },
    { name: 'Nosotros', href: '#nosotros' },
    { name: 'Servicios', href: '#servicios' },
    { name: 'Blog', href: '#blog' },
    { name: 'Contacto', href: '#contacto' },
  ];

  const services = [
    'Vivienda Multifamiliar',
    'Inmuebles Comerciales',
    'Edificación Institucional',
    'Supervisión de Proyectos',
    'Urbanización'
  ];

  return (
    <footer className="bg-[#1a1a1a]" data-testid="footer">
      {/* Top Bar */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-8">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
            <div>
              <h3 className="text-xl font-bold text-white mb-2">¿Listo para comenzar tu proyecto?</h3>
              <p className="text-white/60">Contáctanos hoy para una cotización sin compromiso.</p>
            </div>
            <a
              href="#contacto"
              onClick={(e) => handleNavClick(e, '#contacto')}
              className="inline-flex items-center gap-2 bg-[#2E75B6] text-white px-6 py-3 font-bold uppercase tracking-wider hover:bg-[#203864] transition-colors w-fit"
            >
              Contactar
              <ArrowRight size={16} />
            </a>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="flex flex-col items-center text-center">
            <Link to="/" className="inline-block mb-6" data-testid="footer-logo">
              <img 
                src="https://customer-assets.emergentagent.com/job_eficapro-pro/artifacts/qhp7eory_EFICAPRO%20PNG.png"
                alt="EFICAPRO"
                style={{ height: '6.5rem' }}
                className="w-auto"
              />
            </Link>
            <p className="text-white/60 text-sm leading-relaxed mb-4 text-center">
              Constructora de vanguardia especializada en infraestructura urbana 
              y residencial de alta densidad.
            </p>
            <p className="text-[#2E75B6] text-sm font-semibold">
              Eficacia Profesional
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-white mb-6 uppercase tracking-wider text-sm">
              Enlaces
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    onClick={(e) => handleNavClick(e, link.href)}
                    className="text-white/60 hover:text-[#2E75B6] transition-colors text-sm"
                    data-testid={`footer-link-${link.name.toLowerCase()}`}
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold text-white mb-6 uppercase tracking-wider text-sm">
              Servicios
            </h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service}>
                  <span className="text-white/60 text-sm">{service}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-white mb-6 uppercase tracking-wider text-sm">
              Contacto
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-[#2E75B6] mt-1 flex-shrink-0" />
                <span className="text-white/60 text-sm">
                  Calle Jorge Santayana No. 4965, col. Jardines Universidad, 
                  C.P. 45110, Zapopan, Jalisco.
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-[#2E75B6] flex-shrink-0" />
                <a 
                  href="tel:+523318231064" 
                  className="text-white/60 hover:text-white transition-colors text-sm"
                  data-testid="footer-phone"
                >
                  33 1823 1064
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-[#2E75B6] flex-shrink-0" />
                <a 
                  href="mailto:contacto@eficapro.com" 
                  className="text-white/60 hover:text-white transition-colors text-sm"
                  data-testid="footer-email"
                >
                  contacto@eficapro.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6">
          <p className="text-white/40 text-sm text-center">
            © {new Date().getFullYear()} EFICAPRO. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
